import { SCOPE } from '@store/overviewDashboard/index';
import { get } from 'lodash';

const selector = state => get(state, SCOPE);
export default selector;
